import {createRoot} from "react-dom/client";
import ErrorBanner from "../components/ErrorBanner";

export function showError(message: string, onRetry?: () => void) {
    const errorBanner = document.createElement('div') as HTMLElement;
    const el = createRoot(errorBanner);

    el.render(ErrorBanner({message, onRetry}));

    document.getElementById('errors')?.appendChild(errorBanner);
}

export function isJobberUrl(raw: string): boolean {
    try {
        const url = new URL(raw);
        return url.protocol === "https:" &&
            (url.hostname === "getjobber.com" || url.hostname.endsWith(".getjobber.com"));
    } catch {
        return false;
    }
}